import { Component, OnInit } from '@angular/core';
import { BrandingService } from '../../../core/branding/branding.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'ifc-mobile-app-banner',
    templateUrl: './mobile-app-banner.component.html',
    styleUrls: ['./mobile-app-banner.component.scss'],
    standalone: false
})
export class MobileAppBannerComponent implements OnInit {
  private appStoreUrl: string;
  private playStoreUrl: string;

  constructor(private brandingService: BrandingService) {}

  ngOnInit(): void {
    this.brandingService.getBranding$()
      .pipe(
        untilDestroyed(this),
        catchError((error) => {
          console.error(error);
          return EMPTY;
        })
      ).subscribe(data => {
        this.appStoreUrl = data.appStoreUrl;
        this.playStoreUrl = data.playStoreUrl;
      });
  }
  
  onClickGooglePlay(): void {
    window.open(this.playStoreUrl, "_blank");
  }

  onClickAppleStore(): void {
    window.open(this.appStoreUrl, "_blank");
  }
}
